import { render, staticRenderFns } from "./ConnectProtocol.vue?vue&type=template&id=36a0f9b5&"
import script from "./ConnectProtocol.vue?vue&type=script&lang=js&"
export * from "./ConnectProtocol.vue?vue&type=script&lang=js&"
import style0 from "./ConnectProtocol.vue?vue&type=style&index=0&id=36a0f9b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports